var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    {
      staticClass:
        "\n    max-width\n    d-flex\n    flex-grow-1\n    ma-0\n    pa-0\n    flex-column\n    justify-center\n    text-center\n    body-2\n    align-center align-self-center\n  ",
      style: { height: (_vm.height ? _vm.height : 256) + "px" },
      attrs: {
        elevation: 0,
        fluid: "",
        color: "text--secondary text--lighten-1  ",
      },
    },
    [
      _c(
        "div",
        [
          _c("svg-icon", { attrs: { size: "100", iconClass: "empty" } }),
          _c(
            "div",
            { staticClass: "text-h6 mt-n4 text--secondary" },
            [
              _vm.isLoading
                ? _c("v-progress-circular", {
                    attrs: {
                      indeterminate: "",
                      color: "grey",
                      size: "16",
                      width: "1",
                    },
                  })
                : _vm._e(),
              _c("span", [
                _vm._v(
                  _vm._s(
                    _vm.isLoading
                      ? _vm.$t(_vm.data_loading_text)
                      : _vm.$t(_vm.no_data_text)
                  )
                ),
              ]),
            ],
            1
          ),
          _vm.reloadBtn
            ? _c(
                "v-btn",
                {
                  staticClass: "my-1",
                  attrs: {
                    rounded: "",
                    shaped: "",
                    outlined: "",
                    small: "",
                    color: "primary",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("reload")
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t(_vm.reloadBtn)))]
              )
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }